import {useEffect, useRef} from 'react';
import {useEventDetailsStore} from '../../../common';
import {apiRequest} from '../../../common/services/api';
import {EventDetailDto} from '../../../generated/models/EventDetailDto';
import {getOrganizerEventDetailsEndpoint} from '../../../common/constants/endpoints';
import {EventDetailsCard} from '../../card/eventDetailsCard';
import {useUiStore} from '../../../common/stores/useUiStore';
import {useOrganizerStore} from '../../../common/stores/useOrganizerStore';
import {useLocation, useNavigate} from 'react-router-dom';
import routes from '../../routes/routes';
import {mapEventDetailDto} from '../../../utils/mappers';

export default function EventDetailsScreen() {
  const {organizer} = useOrganizerStore();
  const {
    setShowBackButton,
    setIsLoading,
    clearOnBackButtonClick,
    setOnBackButtonClick,
  } = useUiStore(state => state);
  const navigate = useNavigate();
  const {eventDetails, setEventDetails, selectedEventDetailsId} =
    useEventDetailsStore();
  const location = useLocation();
  const openedFromNextPage = location.state.from;

  useEffect(() => {
    setShowBackButton(true);
    setOnBackButtonClick(() => {
      navigate(routes.getAllEvents, {
        state: {
          searchText: location.state?.searchText,
          scrollPosition: location.state?.scrollPosition,
        },
      });
    });
    if (openedFromNextPage) {
      return;
    }
    window.scrollTo(0, 0);
    return () => {
      setShowBackButton(false);
      clearOnBackButtonClick();
    };
  }, []);

  useEffect(() => {
    const getEventDetails = async () => {
      setIsLoading(true);
      const response = await apiRequest<EventDetailDto>({
        endpoint: getOrganizerEventDetailsEndpoint(
          organizer?.id || '',
          selectedEventDetailsId || '',
        ),
        method: 'GET',
      });

      setIsLoading(false);

      if (!response?.data) {
        alert('Something went wrong when retrieving event data');
        return;
      }

      setEventDetails(mapEventDetailDto(response.data));
    };

    getEventDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return eventDetails && <EventDetailsCard event={eventDetails} />;
}
